import Keycloak from 'keycloak-js';
import apiUrl from './src/constants';
const keycloak = new Keycloak({
    url: apiUrl.kavachURL,
    realm: 'xpressbees',
    clientId: 'xbwms-ui'
});
export default {
  init: () => {
    return new Promise((resolve, reject) => {
        
      keycloak
        .init({ onLoad: 'login-required' })
        .then((authenticated) => {
          resolve(authenticated);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  login: () => {
    keycloak.login();
  },

  logout: () => {
    keycloak.logout();
  },

  getToken: () => {
    return keycloak.token;
  },

  isAuthenticated: () => {
    return keycloak.authenticated;
  },
};



//////////////////
// WEBPACK FOOTER
// ./keycloakService.js
// module id = 872
// module chunks = 0